type Listener = () => void;

let count: number | null = null;
const listeners = new Set<Listener>();

// The sidebar badge and the Requests page share this count so a grant or dismissal on the page
// updates the badge without a second read.
export const openRequestCount = {
  get: (): number | null => count,
  set(next: number | null): void {
    if (next === count) return;
    count = next;
    for (const listener of listeners) listener();
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
